<div
  class="template-lib"
  id="template-library"
  [ngClass]="{
    'template-lib__client': clientFacing && !fromExcelAddin,
    'template-lib__excel': fromExcelAddin
  }"
>
  <!-- upload section -->
  <div class="upload-section">
    <div class="upload-section__header">
      <div>
        <nz-input-group [nzPrefix]="suffixIconSearch" nzSize="small">
          <input
            type="text"
            (input)="searchTemplate($event.target.value)"
            nz-input
            placeholder="Template Name"
            width="280px"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span nz-icon nzType="search"></span>
        </ng-template>
      </div>
      <button
        nz-button
        nz-popover
        nzSize="small"
        nzPopoverTitle="Filter"
        nzPopoverTrigger="click"
        nzPopoverPlacement="bottomRight"
        [(nzPopoverVisible)]="showFilter"
        [nzPopoverContent]="contentTemplate"
        nzType="default"
      >
        <i class="fa fa-filter" aria-hidden="true"></i>
      </button>
      <ng-template #contentTemplate style="padding: 8px">
        <h5>Template Type</h5>
        <div style="display: flex; flex-direction: column">
          <label
            style="margin-left: 0"
            nz-checkbox
            *ngFor="let tTypes of templateTypeFilters"
            [nzChecked]="tTypes.selected"
            [(ngModel)]="tTypes.selected"
            >{{ tTypes.text }}</label
          >
        </div>
        <div style="display: flex; gap: 8px; margin-top: 6px">
          <button nz-button nzType="text" (click)="clearFilter()">Clear</button>
          <button nz-button nzType="primary" (click)="submitFilter()">
            Apply
          </button>
        </div>
      </ng-template>
      <button
        *ngIf="!clientFacing"
        nz-button
        nzSize="small"
        class="button ant-btn-primary-hollow"
        (click)="showModal()"
      >
        <span>Upload Template</span>
      </button>
    </div>
    <nz-modal
      *ngIf="!clientFacing"
      [(nzVisible)]="isVisible"
      nzTitle="Upload Template"
      (nzOnCancel)="handleCancel()"
      (nzOnOk)="handleOk()"
      nzWrapClassName="file-upload"
    >
      <ng-container *nzModalContent>
        <div>
          <span>Template name :</span>
          <input
            type="text"
            placeholder="Template name"
            nz-input
            maxlength="50"
            [(ngModel)]="currentDisplayName"
          />
        </div>
        <div style="margin-top: 10px">
          <span>Template type :</span>
          <nz-select
            style="width: 100%"
            nzAllowClear
            nzPlaceHolder="Select Template type"
            [(ngModel)]="currenTemplateType"
          >
            <nz-option
              *ngFor="let tTypes of templateTypeFilters"
              [nzLabel]="tTypes.text"
              [nzValue]="tTypes.value"
            ></nz-option>
          </nz-select>
        </div>
        <div style="margin-top: 10px">
          <span>Template description</span>
          <input
            type="text"
            nz-input
            placeholder="Template description"
            [(ngModel)]="currentDisplayDescription"
          />
        </div>
        <form>
          <div class="text-center">
            <input
              type="file"
              class="custom-file-input"
              id="customFile"
              name="current_file"
              (change)="onFileSelect($event)"
              #UploadFileInput
            />
            <label class="custom-file-label" for="customFile"
              ><i nz-icon nzType="upload" class="upload-icon"></i
              ><span>Select file</span></label
            >
            <span class="file-input-label" *ngIf="fileInputLabel != ''">
              Selected file : {{ fileInputLabel }}</span
            >
          </div>
        </form>
      </ng-container>
    </nz-modal>
  </div>
  <!-- grid section -->
  <div *ngIf="!showDragPage" [hidden]="" class="template-grid">
    <nz-table
      #sortTable
      [nzFrontPagination]="false"
      [nzShowPagination]="true"
      [nzHideOnSinglePage]="true"
      [nzTemplateMode]="true"
      [nzBordered]="true"
      [nzLoading]="loading"
      nzSize="small"
    >
      <thead class="header">
        <tr>
          <th
            *ngFor="let column of listOfColumns"
            [nzAlign]="column.textAlign"
            [nzShowSort]="column.showSort"
            [nzSortFn]="column.sortFn"
            [nzFilters]="column.listOfFilter"
            [nzWidth]="column.minWidth"
            [nzShowFilter]="column.showFilter"
            (nzSortOrderChange)="getSortedData($event, column.name)"
          >
            <strong>{{ column.name }}</strong>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of filteredTemplatesFiles">
          <td
            nz-tooltip
            [nzTooltipTitle]="fromExcelAddin ? file.templateDescription : ''"
            class="context-area"
          >
            <div class="editable-cell" [hidden]="editId === file.fileId">
              <a (click)="downloadTemplate(file)">{{ file.displayFileName }}</a>
            </div>
            <input
              [hidden]="editId !== file.fileId"
              type="text"
              nz-input
              [(ngModel)]="selectedFileName"
            />
          </td>
          <td *ngIf="!fromExcelAddin">
            <span>{{ file.templateDescription }}</span>
          </td>
          <td *ngIf="!fromExcelAddin">
            <span>{{ file.templateType }}</span>
          </td>
          <td>
            <span>{{ file.lastModified | date: "dd MMM yyyy" }}</span>
          </td>
          <td *ngIf="!clientFacing" class="edit-col">
            <div class="template-action">
              <a
                *ngIf="file.isActive === 1"
                [hidden]="editId == file.fileId"
                (click)="updateTemplateVisibility(file, 'unpublish')"
              >
                Unpublish
              </a>
              <a
                *ngIf="file.isActive === 0"
                [hidden]="editId == file.fileId"
                (click)="updateTemplateVisibility(file, 'publish')"
              >
                Publish
              </a>
              <a
                [hidden]="editId == file.fileId"
                (click)="showEditFirmModal(file)"
              >
                Edit
              </a>
              <a
                [hidden]="editId !== file.fileId"
                (click)="stopEdit(file, true)"
              >
                Save
              </a>
              <a
                [hidden]="editId !== file.fileId"
                (click)="stopEdit(file, false)"
              >
                Cancel
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <!-- <nz-modal
      [(nzVisible)]="isEditFirmVisible"
      nzTitle="Edit firm access"
      (nzOnCancel)="handleFirmCancel()"
      (nzOnOk)="handleFirmOk()"
    >
      <div id="search-add-container">
        <div class="select-firms-container">
          <div class="select-firms">
            <nz-select
              nzPlaceHolder="Select"
              nzAllowClear
              nzShowSearch
              [nzServerSearch]="true"
              [(ngModel)]="selectedFirm"
              class="filter"
              style="width: 100%"
              (ngModelChange)="onFirmChange()"
              [nzDropdownClassName]="'select-dropdown-style'"
            >
              <nz-option-group>
                <ng-container *ngFor="let o of firms; index as i">
                  <nz-option
                    [nzValue]="o"
                    [nzLabel]="o.label"
                    class="opt"
                  ></nz-option>
                </ng-container>
              </nz-option-group>
            </nz-select>
          </div>
          <div class="add-all-firms">
            <button
              [nzSize]="'small'"
              nz-button
              (click)="addAllFirms()"
              class="button ant-btn-primary"
            >
              <span>Add All Firms</span>
            </button>
          </div>
        </div>
        <div class="table-container">
          <nz-table
            class="firm-selection"
            [nzData]="currentFirmSelection"
            nzSize="small"
            nzShowPagination="false"
            nzBordered
            [nzScroll]="{ y: '250px', x: 'auto' }"
            [nzFooter]="selectedFooter"
          >
            <thead>
              <tr>
                <th
                  class="checkbox-sm checkbox-black"
                  [nzShowCheckbox]="true"
                  [(nzChecked)]="checked"
                  [nzIndeterminate]="indeterminate"
                  (nzCheckedChange)="onAllChecked($event)"
                  nzWidth="28px"
                ></th>
                <th nzWidth="auto">Firm Name</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let data of currentFirmSelection"
                [ngClass]="{
                  'error-row': data.hasError
                }"
              >
                <ng-container *ngIf="data.hasError">
                  <td
                    class="checkbox-sm checkbox-black"
                    [nzShowCheckbox]="true"
                    [nzChecked]="deleteSelectedFirms.has(data.id)"
                    (nzCheckedChange)="onItemChecked(data.id, $event)"
                    nzWidth="28px"
                  ></td>
                  <td nzWidth="auto">
                    Error - <span class="error-text">{{ data.errorMsg }}</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="!data.hasError">
                  <td
                    class="checkbox-sm checkbox-black"
                    [nzShowCheckbox]="true"
                    [nzChecked]="deleteSelectedFirms.has(data.id)"
                    (nzCheckedChange)="onItemChecked(data.id, $event)"
                    nzWidth="28px"
                  ></td>
                  <td nzWidth="auto">
                    <span *ngIf="data.label.length <= 28">
                      <span class="grid-text">
                        {{ data.label }}
                      </span>
                    </span>
                    <span
                      *ngIf="data.label.length > 28"
                      [nzTooltipTitle]="data.label"
                      nz-tooltip
                    >
                      <span class="grid-text">
                        {{ data.label }}
                      </span>
                    </span>
                  </td>
                </ng-container>
              </tr>
            </tbody>
            <ng-template #selectedFooter>
              <div
                class="remove-firms"
                [ngClass]="{ hide: !indeterminate && !checked }"
                (click)="removeFirms()"
              >
                <span>
                  <va-icon class="remove-icon" name="close"> </va-icon>
                  <span>Remove Selected Rows</span>
                </span>
              </div>
            </ng-template>
          </nz-table>
        </div>
      </div>
    </nz-modal> -->
  </div>
  <div *ngIf="showDragPage && !clientFacing" class="template-drop-zone">
    <h1 class="template-drop-zone__color">Drop File here</h1>
  </div>
</div>
